import { restRequest } from "vrcore-dashboard/dist/utilities";
export const GET_REPORT_TYPES = restRequest(
    "VRCORE.TIMESHEET_MANAGER.GET_REPORT_TYPES"
);
export const GET_USERS = restRequest("VRCORE.TIMESHEET_MANAGER.GET_USERS");
export const SET_USER = "VRCORE.TIMESHEET_MANAGER.SET_USER";
export const SET_WEEK = "VRCORE.TIMESHEET_MANAGER.SET_WEEK";
export const SET_YEAR = "VRCORE.TIMESHEET_MANAGER.SET_YEAR";
